module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-01.80de41fb.png";